import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "public-layout" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "main-content" }

import Nav from '@/components/Nav';

export default /*@__PURE__*/_defineComponent({
  __name: 'PublicLayout',
  setup(__props) {

// eslint-disable-next-line vue/block-tag-newline

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Nav)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})